// extracted by mini-css-extract-plugin
export default {"flex":"GT","imgwrap":"HT","image":"IT","textinfo":"JT","producttitle":"KT","bolder":"LT","block":"MT","info":"NT","moredetails":"OT","whitebox":"PT","old_price":"QT","discount":"RT"};
    if(module.hot) {
      // 1715091682662
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  